import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "./api";
import { apiErrorToast } from "./api-error-toast";
import { sessionReducer } from "@/features/auth";

/**
 * Store.
 *
 * Almost all state here is server state, and RTK Query owns it. The only
 * hand-written slice is `session` — who is signed in and what they may do —
 * because that is genuinely client state.
 *
 * If you find yourself adding a slice to hold data that came from the API,
 * that data belongs in an RTK Query endpoint instead.
 */
export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    session: sessionReducer,
  },
  // `apiErrorToast` after the api middleware: it reads the rejection that
  // middleware produces, so it has to be downstream of it.
  middleware: (getDefault) => getDefault().concat(api.middleware, apiErrorToast),
  devTools: import.meta.env.DEV,
});

// Enables refetchOnFocus / refetchOnReconnect. An ops panel left open on a
// second monitor should not show yesterday's numbers when you look back at it.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
